// This file is auto-generated by @hey-api/openapi-ts

import {
  type DefaultError,
  queryOptions,
  type UseMutationOptions,
} from "@tanstack/react-query";

import { client } from "../client.gen";
import {
  calculateSavedPaymentAccountTransactions,
  cancelDepositTransaction,
  cancelWithdrawalRequest,
  createDocument,
  createSavedPaymentAccount,
  createSavedPaymentAccountDeletionRequestById,
  emailVerifyWithdrawalRequest,
  getCashierV1AuthenticationLogin,
  getCashierV1AuthenticationOauth,
  getCashierV1AuthenticationVerify,
  getCurrencies,
  getDocumentById,
  getExchangeRate,
  getFreeMargin,
  getInternalCodes,
  getOrCreateCashierUser,
  getPageAlert,
  getPaymentMethodGroupById,
  getRawExchangeRate,
  getSavedPaymentAccountsProfit,
  getTradingAccountRefundBalance,
  getTradingAccounts,
  getTransactionDetails,
  getTransactions,
  getTransactionStatus,
  getTransferExchangeRate,
  getWithdrawalRequestAmount,
  getWithdrawalRequestStatus,
  health,
  initSessionToken,
  internalTransferConfirm,
  internalTransferCreate,
  type Options,
  otpVerifyWithdrawalRequest,
  paymentMethods,
  resendEmailVerificationWithdrawalRequest,
  saveWithdrawalRequest,
  startTransaction,
  updateCardExpiryDate,
  updateDocumentStatusById,
  updateTransaction,
  version,
  withdrawalPaymentMethods,
} from "../sdk.gen";
import type {
  CalculateSavedPaymentAccountTransactionsData,
  CalculateSavedPaymentAccountTransactionsError,
  CalculateSavedPaymentAccountTransactionsResponse,
  CancelDepositTransactionData,
  CancelDepositTransactionError,
  CancelDepositTransactionResponse,
  CancelWithdrawalRequestData,
  CancelWithdrawalRequestError,
  CancelWithdrawalRequestResponse,
  CreateDocumentData,
  CreateDocumentError,
  CreateDocumentResponse,
  CreateSavedPaymentAccountData,
  CreateSavedPaymentAccountDeletionRequestByIdData,
  CreateSavedPaymentAccountDeletionRequestByIdError,
  CreateSavedPaymentAccountDeletionRequestByIdResponse,
  CreateSavedPaymentAccountError,
  CreateSavedPaymentAccountResponse,
  EmailVerifyWithdrawalRequestData,
  EmailVerifyWithdrawalRequestError,
  EmailVerifyWithdrawalRequestResponse,
  GetCashierV1AuthenticationLoginData,
  GetCashierV1AuthenticationLoginError,
  GetCashierV1AuthenticationOauthData,
  GetCashierV1AuthenticationOauthError,
  GetCashierV1AuthenticationOauthResponse,
  GetCashierV1AuthenticationVerifyData,
  GetCashierV1AuthenticationVerifyError,
  GetCashierV1AuthenticationVerifyResponse,
  GetCurrenciesData,
  GetCurrenciesError,
  GetCurrenciesResponse,
  GetDocumentByIdData,
  GetDocumentByIdError,
  GetDocumentByIdResponse,
  GetExchangeRateData,
  GetExchangeRateError,
  GetExchangeRateResponse,
  GetFreeMarginData,
  GetFreeMarginError,
  GetFreeMarginResponse,
  GetInternalCodesData,
  GetInternalCodesError,
  GetInternalCodesResponse,
  GetOrCreateCashierUserData,
  GetOrCreateCashierUserError,
  GetOrCreateCashierUserResponse,
  GetPageAlertData,
  GetPageAlertError,
  GetPageAlertResponse,
  GetPaymentMethodGroupByIdData,
  GetPaymentMethodGroupByIdError,
  GetPaymentMethodGroupByIdResponse,
  GetRawExchangeRateData,
  GetRawExchangeRateError,
  GetRawExchangeRateResponse,
  GetSavedPaymentAccountsProfitData,
  GetSavedPaymentAccountsProfitError,
  GetSavedPaymentAccountsProfitResponse,
  GetTradingAccountRefundBalanceData,
  GetTradingAccountRefundBalanceError,
  GetTradingAccountRefundBalanceResponse,
  GetTradingAccountsData,
  GetTradingAccountsError,
  GetTradingAccountsResponse,
  GetTransactionDetailsData,
  GetTransactionDetailsError,
  GetTransactionDetailsResponse,
  GetTransactionsData,
  GetTransactionsError,
  GetTransactionsResponse,
  GetTransactionStatusData,
  GetTransactionStatusError,
  GetTransactionStatusResponse,
  GetTransferExchangeRateData,
  GetTransferExchangeRateError,
  GetTransferExchangeRateResponse,
  GetWithdrawalRequestAmountData,
  GetWithdrawalRequestAmountError,
  GetWithdrawalRequestAmountResponse,
  GetWithdrawalRequestStatusData,
  GetWithdrawalRequestStatusError,
  GetWithdrawalRequestStatusResponse,
  HealthData,
  HealthResponse,
  InitSessionTokenData,
  InitSessionTokenError,
  InitSessionTokenResponse2,
  InternalTransferConfirmData,
  InternalTransferConfirmError,
  InternalTransferConfirmResponse,
  InternalTransferCreateData,
  InternalTransferCreateError,
  InternalTransferCreateResponse,
  OtpVerifyWithdrawalRequestData,
  OtpVerifyWithdrawalRequestError,
  OtpVerifyWithdrawalRequestResponse,
  PaymentMethodsData,
  PaymentMethodsError,
  PaymentMethodsResponse,
  ResendEmailVerificationWithdrawalRequestData,
  ResendEmailVerificationWithdrawalRequestError,
  ResendEmailVerificationWithdrawalRequestResponse,
  SaveWithdrawalRequestData,
  SaveWithdrawalRequestError,
  SaveWithdrawalRequestResponse,
  StartTransactionData,
  StartTransactionError,
  StartTransactionResponse,
  UpdateCardExpiryDateData,
  UpdateCardExpiryDateError,
  UpdateDocumentStatusByIdData,
  UpdateDocumentStatusByIdError,
  UpdateDocumentStatusByIdResponse,
  UpdateTransactionData,
  UpdateTransactionError,
  UpdateTransactionResponse,
  VersionData,
  VersionError,
  VersionResponse,
  WithdrawalPaymentMethodsData,
  WithdrawalPaymentMethodsError,
  WithdrawalPaymentMethodsResponse,
} from "../types.gen";

export type QueryKey<TOptions extends Options> = [
  Pick<TOptions, "baseUrl" | "body" | "headers" | "path" | "query"> & {
    _id: string;
    _infinite?: boolean;
    tags?: ReadonlyArray<string>;
  },
];

const createQueryKey = <TOptions extends Options>(
  id: string,
  options?: TOptions,
  infinite?: boolean,
  tags?: ReadonlyArray<string>
): [QueryKey<TOptions>[0]] => {
  const params: QueryKey<TOptions>[0] = {
    _id: id,
    baseUrl:
      options?.baseUrl || (options?.client ?? client).getConfig().baseUrl,
  } as QueryKey<TOptions>[0];
  if (infinite) {
    params._infinite = infinite;
  }
  if (tags) {
    params.tags = tags;
  }
  if (options?.body) {
    params.body = options.body;
  }
  if (options?.headers) {
    params.headers = options.headers;
  }
  if (options?.path) {
    params.path = options.path;
  }
  if (options?.query) {
    params.query = options.query;
  }
  return [params];
};

export const healthQueryKey = (options?: Options<HealthData>) =>
  createQueryKey("health", options);

/**
 * PNX Cashier Service health check
 */
export const healthOptions = (options?: Options<HealthData>) =>
  queryOptions<
    HealthResponse,
    DefaultError,
    HealthResponse,
    ReturnType<typeof healthQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await health({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: healthQueryKey(options),
  });

export const versionQueryKey = (options?: Options<VersionData>) =>
  createQueryKey("version", options);

/**
 * PNX Cashier Service backend build commit hash and time
 */
export const versionOptions = (options?: Options<VersionData>) =>
  queryOptions<
    VersionResponse,
    VersionError,
    VersionResponse,
    ReturnType<typeof versionQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await version({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: versionQueryKey(options),
  });

export const getCashierV1AuthenticationLoginQueryKey = (
  options?: Options<GetCashierV1AuthenticationLoginData>
) => createQueryKey("getCashierV1AuthenticationLogin", options);

/**
 * Customer login
 */
export const getCashierV1AuthenticationLoginOptions = (
  options?: Options<GetCashierV1AuthenticationLoginData>
) =>
  queryOptions<
    unknown,
    GetCashierV1AuthenticationLoginError,
    unknown,
    ReturnType<typeof getCashierV1AuthenticationLoginQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getCashierV1AuthenticationLogin({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getCashierV1AuthenticationLoginQueryKey(options),
  });

export const getCashierV1AuthenticationOauthQueryKey = (
  options: Options<GetCashierV1AuthenticationOauthData>
) => createQueryKey("getCashierV1AuthenticationOauth", options);

/**
 * OAuth2 callback for customer
 */
export const getCashierV1AuthenticationOauthOptions = (
  options: Options<GetCashierV1AuthenticationOauthData>
) =>
  queryOptions<
    GetCashierV1AuthenticationOauthResponse,
    GetCashierV1AuthenticationOauthError,
    GetCashierV1AuthenticationOauthResponse,
    ReturnType<typeof getCashierV1AuthenticationOauthQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getCashierV1AuthenticationOauth({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getCashierV1AuthenticationOauthQueryKey(options),
  });

export const getCashierV1AuthenticationVerifyQueryKey = (
  options: Options<GetCashierV1AuthenticationVerifyData>
) => createQueryKey("getCashierV1AuthenticationVerify", options);

/**
 * Verify an customer Auth0 token
 */
export const getCashierV1AuthenticationVerifyOptions = (
  options: Options<GetCashierV1AuthenticationVerifyData>
) =>
  queryOptions<
    GetCashierV1AuthenticationVerifyResponse,
    GetCashierV1AuthenticationVerifyError,
    GetCashierV1AuthenticationVerifyResponse,
    ReturnType<typeof getCashierV1AuthenticationVerifyQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getCashierV1AuthenticationVerify({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getCashierV1AuthenticationVerifyQueryKey(options),
  });

export const getOrCreateCashierUserQueryKey = (
  options?: Options<GetOrCreateCashierUserData>
) => createQueryKey("getOrCreateCashierUser", options);

/**
 * Get or create customer data
 */
export const getOrCreateCashierUserOptions = (
  options?: Options<GetOrCreateCashierUserData>
) =>
  queryOptions<
    GetOrCreateCashierUserResponse,
    GetOrCreateCashierUserError,
    GetOrCreateCashierUserResponse,
    ReturnType<typeof getOrCreateCashierUserQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getOrCreateCashierUser({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getOrCreateCashierUserQueryKey(options),
  });

/**
 * Create a transaction to transfer funds between two internal trading accounts
 */
export const internalTransferCreateMutation = (
  options?: Partial<Options<InternalTransferCreateData>>
): UseMutationOptions<
  InternalTransferCreateResponse,
  InternalTransferCreateError,
  Options<InternalTransferCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    InternalTransferCreateResponse,
    InternalTransferCreateError,
    Options<InternalTransferCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await internalTransferCreate({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Confirm a transaction to transfer funds between two internal trading accounts
 */
export const internalTransferConfirmMutation = (
  options?: Partial<Options<InternalTransferConfirmData>>
): UseMutationOptions<
  InternalTransferConfirmResponse,
  InternalTransferConfirmError,
  Options<InternalTransferConfirmData>
> => {
  const mutationOptions: UseMutationOptions<
    InternalTransferConfirmResponse,
    InternalTransferConfirmError,
    Options<InternalTransferConfirmData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await internalTransferConfirm({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getInternalCodesQueryKey = (
  options: Options<GetInternalCodesData>
) => createQueryKey("getInternalCodes", options);

/**
 * Upon receiving a series of standardized inputs (ISO, license names etc) this endpoint returns with their corresponding internal representations while also verifying their existance.
 */
export const getInternalCodesOptions = (
  options: Options<GetInternalCodesData>
) =>
  queryOptions<
    GetInternalCodesResponse,
    GetInternalCodesError,
    GetInternalCodesResponse,
    ReturnType<typeof getInternalCodesQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getInternalCodes({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getInternalCodesQueryKey(options),
  });

export const getTransactionsQueryKey = (
  options?: Options<GetTransactionsData>
) => createQueryKey("getTransactions", options);

/**
 * Get all transactions for a customer.
 * This method should be used in the cashier page to display the transaction history for the user.
 * It returns all types of transactions (deposit, withdrawal, internal transfer) for the user sorted by creation date, newest first.
 *
 */
export const getTransactionsOptions = (
  options?: Options<GetTransactionsData>
) =>
  queryOptions<
    GetTransactionsResponse,
    GetTransactionsError,
    GetTransactionsResponse,
    ReturnType<typeof getTransactionsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getTransactions({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getTransactionsQueryKey(options),
  });

export const getTransactionDetailsQueryKey = (
  options: Options<GetTransactionDetailsData>
) => createQueryKey("getTransactionDetails", options);

/**
 * Get transaction details. This method is used in the cashier history page to display the transaction details and timeline for the customer.
 *
 */
export const getTransactionDetailsOptions = (
  options: Options<GetTransactionDetailsData>
) =>
  queryOptions<
    GetTransactionDetailsResponse,
    GetTransactionDetailsError,
    GetTransactionDetailsResponse,
    ReturnType<typeof getTransactionDetailsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getTransactionDetails({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getTransactionDetailsQueryKey(options),
  });

export const getTransactionStatusQueryKey = (
  options: Options<GetTransactionStatusData>
) => createQueryKey("getTransactionStatus", options);

/**
 * Get transaction status
 *
 * Get status of a specific transaction by reference ID and payment type (either deposit or withdrawal). Intended to be used after a transaction was executed to get information about the final balance and the status of the transaction. Returns the latest status of the transaction.
 */
export const getTransactionStatusOptions = (
  options: Options<GetTransactionStatusData>
) =>
  queryOptions<
    GetTransactionStatusResponse,
    GetTransactionStatusError,
    GetTransactionStatusResponse,
    ReturnType<typeof getTransactionStatusQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getTransactionStatus({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getTransactionStatusQueryKey(options),
  });

export const getExchangeRateQueryKey = (
  options: Options<GetExchangeRateData>
) => createQueryKey("getExchangeRate", options);

/**
 * Get exchange rate receives a pair of currency id along with an amount representing the convertable amount and returns the converted amount along with the used rate. This endpoint is used to determine the displayed amounts within the cashier page when the processing currency does not match the trading currency of the customer. The endpoint also expects various user related parameters in order to determine the appropriate fees and rounding settings that should be applied to the given user cohort.
 */
export const getExchangeRateOptions = (options: Options<GetExchangeRateData>) =>
  queryOptions<
    GetExchangeRateResponse,
    GetExchangeRateError,
    GetExchangeRateResponse,
    ReturnType<typeof getExchangeRateQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getExchangeRate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getExchangeRateQueryKey(options),
  });

export const getRawExchangeRateQueryKey = (
  options: Options<GetRawExchangeRateData>
) => createQueryKey("getRawExchangeRate", options);

/**
 * Get raw exchange rate receives a pair of currency id along with an amount representing the convertable amount and returns the converted amount along with the used rate. It does not take user parameters into account, only passes the value to the appropriate exchange rate API (based on whether they are fiat or crypto). It is used within the internal transfer page where the various cashier settings are irrelevant.
 */
export const getRawExchangeRateOptions = (
  options: Options<GetRawExchangeRateData>
) =>
  queryOptions<
    GetRawExchangeRateResponse,
    GetRawExchangeRateError,
    GetRawExchangeRateResponse,
    ReturnType<typeof getRawExchangeRateQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getRawExchangeRate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getRawExchangeRateQueryKey(options),
  });

export const getTransferExchangeRateQueryKey = (
  options: Options<GetTransferExchangeRateData>
) => createQueryKey("getTransferExchangeRate", options);

/**
 * Get transfer exchange rate receives a pair of currency IDs along with transfer "from amount" and returns a calculated exchange fee, target amount, and a timestamp to set the expiry of the rate.
 */
export const getTransferExchangeRateOptions = (
  options: Options<GetTransferExchangeRateData>
) =>
  queryOptions<
    GetTransferExchangeRateResponse,
    GetTransferExchangeRateError,
    GetTransferExchangeRateResponse,
    ReturnType<typeof getTransferExchangeRateQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getTransferExchangeRate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getTransferExchangeRateQueryKey(options),
  });

export const getTradingAccountsQueryKey = (
  options?: Options<GetTradingAccountsData>
) => createQueryKey("getTradingAccounts", options);

/**
 * Get trading accounts sorted by free margin (descending, normalized to AUD)
 */
export const getTradingAccountsOptions = (
  options?: Options<GetTradingAccountsData>
) =>
  queryOptions<
    GetTradingAccountsResponse,
    GetTradingAccountsError,
    GetTradingAccountsResponse,
    ReturnType<typeof getTradingAccountsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getTradingAccounts({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getTradingAccountsQueryKey(options),
  });

export const getCurrenciesQueryKey = (options?: Options<GetCurrenciesData>) =>
  createQueryKey("getCurrencies", options);

/**
 * Get all available currencies
 */
export const getCurrenciesOptions = (options?: Options<GetCurrenciesData>) =>
  queryOptions<
    GetCurrenciesResponse,
    GetCurrenciesError,
    GetCurrenciesResponse,
    ReturnType<typeof getCurrenciesQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getCurrencies({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getCurrenciesQueryKey(options),
  });

export const getPageAlertQueryKey = (options?: Options<GetPageAlertData>) =>
  createQueryKey("getPageAlert", options);

/**
 * Get the last active page alert for the cashier page
 */
export const getPageAlertOptions = (options?: Options<GetPageAlertData>) =>
  queryOptions<
    GetPageAlertResponse,
    GetPageAlertError,
    GetPageAlertResponse,
    ReturnType<typeof getPageAlertQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getPageAlert({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getPageAlertQueryKey(options),
  });

/**
 * Update card expiry date (format is MM/YY)
 */
export const updateCardExpiryDateMutation = (
  options?: Partial<Options<UpdateCardExpiryDateData>>
): UseMutationOptions<
  unknown,
  UpdateCardExpiryDateError,
  Options<UpdateCardExpiryDateData>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    UpdateCardExpiryDateError,
    Options<UpdateCardExpiryDateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await updateCardExpiryDate({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Start a deposit transaction
 *
 * Starts the transaction. The endpoint will not only register a transaction entry in the system but attempts to execute it directly with the payment service provider. The endpoint should be used by the customer when hitting deposit on the payment provider of their choice, and ideally should execute the entire deposit flow with no human interaction.
 */
export const startTransactionMutation = (
  options?: Partial<Options<StartTransactionData>>
): UseMutationOptions<
  StartTransactionResponse,
  StartTransactionError,
  Options<StartTransactionData>
> => {
  const mutationOptions: UseMutationOptions<
    StartTransactionResponse,
    StartTransactionError,
    Options<StartTransactionData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await startTransaction({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Update SavedPaymentAccount and fail the transaction if BIN is blocked
 */
export const updateTransactionMutation = (
  options?: Partial<Options<UpdateTransactionData>>
): UseMutationOptions<
  UpdateTransactionResponse,
  UpdateTransactionError,
  Options<UpdateTransactionData>
> => {
  const mutationOptions: UseMutationOptions<
    UpdateTransactionResponse,
    UpdateTransactionError,
    Options<UpdateTransactionData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await updateTransaction({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Cancel a deposit transaction that has been started by the customer but not yet finalised by the PSP
 */
export const cancelDepositTransactionMutation = (
  options?: Partial<Options<CancelDepositTransactionData>>
): UseMutationOptions<
  CancelDepositTransactionResponse,
  CancelDepositTransactionError,
  Options<CancelDepositTransactionData>
> => {
  const mutationOptions: UseMutationOptions<
    CancelDepositTransactionResponse,
    CancelDepositTransactionError,
    Options<CancelDepositTransactionData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await cancelDepositTransaction({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const paymentMethodsQueryKey = (options: Options<PaymentMethodsData>) =>
  createQueryKey("paymentMethods", options);

/**
 * Get payment methods
 *
 * Get payment methods available for a customer
 */
export const paymentMethodsOptions = (options: Options<PaymentMethodsData>) =>
  queryOptions<
    PaymentMethodsResponse,
    PaymentMethodsError,
    PaymentMethodsResponse,
    ReturnType<typeof paymentMethodsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await paymentMethods({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: paymentMethodsQueryKey(options),
  });

export const withdrawalPaymentMethodsQueryKey = (
  options: Options<WithdrawalPaymentMethodsData>
) => createQueryKey("withdrawalPaymentMethods", options);

/**
 * Get withdrawal payment methods
 *
 * Get withdrawal payment methods available for a customer
 */
export const withdrawalPaymentMethodsOptions = (
  options: Options<WithdrawalPaymentMethodsData>
) =>
  queryOptions<
    WithdrawalPaymentMethodsResponse,
    WithdrawalPaymentMethodsError,
    WithdrawalPaymentMethodsResponse,
    ReturnType<typeof withdrawalPaymentMethodsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await withdrawalPaymentMethods({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: withdrawalPaymentMethodsQueryKey(options),
  });

export const getPaymentMethodGroupByIdQueryKey = (
  options: Options<GetPaymentMethodGroupByIdData>
) => createQueryKey("getPaymentMethodGroupById", options);

/**
 * Get details of a given payment method group
 */
export const getPaymentMethodGroupByIdOptions = (
  options: Options<GetPaymentMethodGroupByIdData>
) =>
  queryOptions<
    GetPaymentMethodGroupByIdResponse,
    GetPaymentMethodGroupByIdError,
    GetPaymentMethodGroupByIdResponse,
    ReturnType<typeof getPaymentMethodGroupByIdQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getPaymentMethodGroupById({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getPaymentMethodGroupByIdQueryKey(options),
  });

/**
 * Create a deletion request for a saved payment account
 */
export const createSavedPaymentAccountDeletionRequestByIdMutation = (
  options?: Partial<Options<CreateSavedPaymentAccountDeletionRequestByIdData>>
): UseMutationOptions<
  CreateSavedPaymentAccountDeletionRequestByIdResponse,
  CreateSavedPaymentAccountDeletionRequestByIdError,
  Options<CreateSavedPaymentAccountDeletionRequestByIdData>
> => {
  const mutationOptions: UseMutationOptions<
    CreateSavedPaymentAccountDeletionRequestByIdResponse,
    CreateSavedPaymentAccountDeletionRequestByIdError,
    Options<CreateSavedPaymentAccountDeletionRequestByIdData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await createSavedPaymentAccountDeletionRequestById({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getWithdrawalRequestAmountQueryKey = (
  options: Options<GetWithdrawalRequestAmountData>
) => createQueryKey("getWithdrawalRequestAmount", options);

/**
 * Get withdrawal request amount
 *
 * Get amount of a specific withdrawal request by reference ID
 */
export const getWithdrawalRequestAmountOptions = (
  options: Options<GetWithdrawalRequestAmountData>
) =>
  queryOptions<
    GetWithdrawalRequestAmountResponse,
    GetWithdrawalRequestAmountError,
    GetWithdrawalRequestAmountResponse,
    ReturnType<typeof getWithdrawalRequestAmountQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getWithdrawalRequestAmount({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getWithdrawalRequestAmountQueryKey(options),
  });

export const getTradingAccountRefundBalanceQueryKey = (
  options: Options<GetTradingAccountRefundBalanceData>
) => createQueryKey("getTradingAccountRefundBalance", options);

/**
 * Returns the available funds in the trading account
 */
export const getTradingAccountRefundBalanceOptions = (
  options: Options<GetTradingAccountRefundBalanceData>
) =>
  queryOptions<
    GetTradingAccountRefundBalanceResponse,
    GetTradingAccountRefundBalanceError,
    GetTradingAccountRefundBalanceResponse,
    ReturnType<typeof getTradingAccountRefundBalanceQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getTradingAccountRefundBalance({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getTradingAccountRefundBalanceQueryKey(options),
  });

export const initSessionTokenQueryKey = (
  options: Options<InitSessionTokenData>
) => createQueryKey("initSessionToken", options);

/**
 * Initiate session token for customer
 *
 * Get a session token for WEB SDK to use a saved payment account for a trading account by the CustomerID.
 */
export const initSessionTokenOptions = (
  options: Options<InitSessionTokenData>
) =>
  queryOptions<
    InitSessionTokenResponse2,
    InitSessionTokenError,
    InitSessionTokenResponse2,
    ReturnType<typeof initSessionTokenQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await initSessionToken({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: initSessionTokenQueryKey(options),
  });

/**
 * Create a saved payment account for a trading account.
 */
export const createSavedPaymentAccountMutation = (
  options?: Partial<Options<CreateSavedPaymentAccountData>>
): UseMutationOptions<
  CreateSavedPaymentAccountResponse,
  CreateSavedPaymentAccountError,
  Options<CreateSavedPaymentAccountData>
> => {
  const mutationOptions: UseMutationOptions<
    CreateSavedPaymentAccountResponse,
    CreateSavedPaymentAccountError,
    Options<CreateSavedPaymentAccountData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await createSavedPaymentAccount({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getSavedPaymentAccountsProfitQueryKey = (
  options: Options<GetSavedPaymentAccountsProfitData>
) => createQueryKey("getSavedPaymentAccountsProfit", options);

/**
 * Get all saved payment accounts available to withdraw profit
 */
export const getSavedPaymentAccountsProfitOptions = (
  options: Options<GetSavedPaymentAccountsProfitData>
) =>
  queryOptions<
    GetSavedPaymentAccountsProfitResponse,
    GetSavedPaymentAccountsProfitError,
    GetSavedPaymentAccountsProfitResponse,
    ReturnType<typeof getSavedPaymentAccountsProfitQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getSavedPaymentAccountsProfit({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getSavedPaymentAccountsProfitQueryKey(options),
  });

/**
 * Update Document Status by ID
 */
export const updateDocumentStatusByIdMutation = (
  options?: Partial<Options<UpdateDocumentStatusByIdData>>
): UseMutationOptions<
  UpdateDocumentStatusByIdResponse,
  UpdateDocumentStatusByIdError,
  Options<UpdateDocumentStatusByIdData>
> => {
  const mutationOptions: UseMutationOptions<
    UpdateDocumentStatusByIdResponse,
    UpdateDocumentStatusByIdError,
    Options<UpdateDocumentStatusByIdData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await updateDocumentStatusById({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Create a withdrawal request
 *
 * Recalculate and save transactions for a withdrawal request
 */
export const saveWithdrawalRequestMutation = (
  options?: Partial<Options<SaveWithdrawalRequestData>>
): UseMutationOptions<
  SaveWithdrawalRequestResponse,
  SaveWithdrawalRequestError,
  Options<SaveWithdrawalRequestData>
> => {
  const mutationOptions: UseMutationOptions<
    SaveWithdrawalRequestResponse,
    SaveWithdrawalRequestError,
    Options<SaveWithdrawalRequestData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await saveWithdrawalRequest({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Verify the withdrawal using an MFA code. Call this endpoint after the user has successfully completed two-factor authentication (2FA).
 */
export const otpVerifyWithdrawalRequestMutation = (
  options?: Partial<Options<OtpVerifyWithdrawalRequestData>>
): UseMutationOptions<
  OtpVerifyWithdrawalRequestResponse,
  OtpVerifyWithdrawalRequestError,
  Options<OtpVerifyWithdrawalRequestData>
> => {
  const mutationOptions: UseMutationOptions<
    OtpVerifyWithdrawalRequestResponse,
    OtpVerifyWithdrawalRequestError,
    Options<OtpVerifyWithdrawalRequestData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await otpVerifyWithdrawalRequest({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const emailVerifyWithdrawalRequestQueryKey = (
  options: Options<EmailVerifyWithdrawalRequestData>
) => createQueryKey("emailVerifyWithdrawalRequest", options);

/**
 * Verify the withdrawal request using an email verification. Call this endpoint after the user has opened the verification link in their email. The `emailVerificationToken` query parameter is a secret token (distinct from the withdrawal request ID) that is only present in the verification email.
 */
export const emailVerifyWithdrawalRequestOptions = (
  options: Options<EmailVerifyWithdrawalRequestData>
) =>
  queryOptions<
    EmailVerifyWithdrawalRequestResponse,
    EmailVerifyWithdrawalRequestError,
    EmailVerifyWithdrawalRequestResponse,
    ReturnType<typeof emailVerifyWithdrawalRequestQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await emailVerifyWithdrawalRequest({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: emailVerifyWithdrawalRequestQueryKey(options),
  });

export const cancelWithdrawalRequestQueryKey = (
  options: Options<CancelWithdrawalRequestData>
) => createQueryKey("cancelWithdrawalRequest", options);

/**
 * Cancel the withdrawal request. Call this endpoint to cancel a pending withdrawal request.
 */
export const cancelWithdrawalRequestOptions = (
  options: Options<CancelWithdrawalRequestData>
) =>
  queryOptions<
    CancelWithdrawalRequestResponse,
    CancelWithdrawalRequestError,
    CancelWithdrawalRequestResponse,
    ReturnType<typeof cancelWithdrawalRequestQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await cancelWithdrawalRequest({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: cancelWithdrawalRequestQueryKey(options),
  });

export const getWithdrawalRequestStatusQueryKey = (
  options: Options<GetWithdrawalRequestStatusData>
) => createQueryKey("getWithdrawalRequestStatus", options);

/**
 * Get the current status of a withdrawal request without mutating it.
 */
export const getWithdrawalRequestStatusOptions = (
  options: Options<GetWithdrawalRequestStatusData>
) =>
  queryOptions<
    GetWithdrawalRequestStatusResponse,
    GetWithdrawalRequestStatusError,
    GetWithdrawalRequestStatusResponse,
    ReturnType<typeof getWithdrawalRequestStatusQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getWithdrawalRequestStatus({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getWithdrawalRequestStatusQueryKey(options),
  });

/**
 * Resend the email verification for a withdrawal request. Call this endpoint to resend the verification email.
 */
export const resendEmailVerificationWithdrawalRequestMutation = (
  options?: Partial<Options<ResendEmailVerificationWithdrawalRequestData>>
): UseMutationOptions<
  ResendEmailVerificationWithdrawalRequestResponse,
  ResendEmailVerificationWithdrawalRequestError,
  Options<ResendEmailVerificationWithdrawalRequestData>
> => {
  const mutationOptions: UseMutationOptions<
    ResendEmailVerificationWithdrawalRequestResponse,
    ResendEmailVerificationWithdrawalRequestError,
    Options<ResendEmailVerificationWithdrawalRequestData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await resendEmailVerificationWithdrawalRequest({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Calculate transactions based saved payment accounts withdraw details
 */
export const calculateSavedPaymentAccountTransactionsMutation = (
  options?: Partial<Options<CalculateSavedPaymentAccountTransactionsData>>
): UseMutationOptions<
  CalculateSavedPaymentAccountTransactionsResponse,
  CalculateSavedPaymentAccountTransactionsError,
  Options<CalculateSavedPaymentAccountTransactionsData>
> => {
  const mutationOptions: UseMutationOptions<
    CalculateSavedPaymentAccountTransactionsResponse,
    CalculateSavedPaymentAccountTransactionsError,
    Options<CalculateSavedPaymentAccountTransactionsData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await calculateSavedPaymentAccountTransactions({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getDocumentByIdQueryKey = (
  options: Options<GetDocumentByIdData>
) => createQueryKey("getDocumentById", options);

/**
 * Get Document by ID
 */
export const getDocumentByIdOptions = (options: Options<GetDocumentByIdData>) =>
  queryOptions<
    GetDocumentByIdResponse,
    GetDocumentByIdError,
    GetDocumentByIdResponse,
    ReturnType<typeof getDocumentByIdQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getDocumentById({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getDocumentByIdQueryKey(options),
  });

/**
 * Create a new document and get a presigned url. If the SPA ID is present, the document will be linked to the SPA. Otherwise, the document will be created without a link as a general upload for purposes like deletion request.
 */
export const createDocumentMutation = (
  options?: Partial<Options<CreateDocumentData>>
): UseMutationOptions<
  CreateDocumentResponse,
  CreateDocumentError,
  Options<CreateDocumentData>
> => {
  const mutationOptions: UseMutationOptions<
    CreateDocumentResponse,
    CreateDocumentError,
    Options<CreateDocumentData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await createDocument({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getFreeMarginQueryKey = (options: Options<GetFreeMarginData>) =>
  createQueryKey("getFreeMargin", options);

/**
 * Gets free margin amount by trading account ID
 */
export const getFreeMarginOptions = (options: Options<GetFreeMarginData>) =>
  queryOptions<
    GetFreeMarginResponse,
    GetFreeMarginError,
    GetFreeMarginResponse,
    ReturnType<typeof getFreeMarginQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getFreeMargin({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getFreeMarginQueryKey(options),
  });
